module.exports = __webpack_public_path__ + "img/customers.02e7a376.png";